import { render, staticRenderFns } from "./food.manage.modal.vue?vue&type=template&id=777d639f&scoped=true&"
import script from "./food.manage.modal.vue?vue&type=script&lang=js&"
export * from "./food.manage.modal.vue?vue&type=script&lang=js&"
import style0 from "./food.manage.modal.vue?vue&type=style&index=0&id=777d639f&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "777d639f",
  null
  
)

export default component.exports